import { Component, OnInit } from '@angular/core';
import { AppComponent} from '../../app.component';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
export class FeatureData {
  FeatureID:any;
  FeatureDs : string;
  ModuleID:any;
  ModuleDs : string;
  recEnable: any;
  IsClient: any;
}

@Component({
    selector: 'app-feature-entry',
    templateUrl: './feature-entry.component.html',
    styleUrls: ['./feature-entry.component.css'],
    standalone: false
})

export class FeatureEntryComponent implements OnInit {
  url: string;
  FeatureID:string;
  pageurl:string;
  FeatureEntry: FormGroup;
  FeatureData:any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.FeatureEntry = this.formBuilder.group({
    });

    const formGroup = {};

    formGroup['FeatureID'] = new FormControl("");
    formGroup['chkToClient'] = new FormControl("");
    formGroup['chkIsActive'] = new FormControl("");
    this.FeatureEntry = new FormGroup(formGroup);

    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.FeatureID = pagehead[2];
    this.FeatureData = new FeatureData();
    this.LoadFeature();
  }

  LoadFeature()
  {
    this.http.get(this.url + 'AlertNotificationDetail/GetFeature?FeatureID=' + this.FeatureID)
    .subscribe( (data) => {
      console.log(data);
        if (data == null || data.toString() == "[]") {

        } else {
           this.FeatureData = JSON.parse(data.toString());
        }
      },
      (error) => {
       }
    );
  }

  onFeatureSubmit(Data)
  {
    this.http.post(this.url + 'AlertNotificationDetail/UpdateFeature', Data) .subscribe( (data) => {
      if (data == null) {
        this.alertService.error('An Error Occurred', true);
      } else {
        this.alertService.success(data.toString() , this.options);
      }
     }
   );
  }

}
